// istanbul ignore file -- constant file
import { UserSegmentationDataProvider } from '@ori/presentation-http';

import {
  AppPromoProvider,
  CataloguesProvider,
  ConsultantProvider,
  HeadersProvider,
  TopAreaBannerProvider,
} from '../context';
import {
  AboutTilesProvider,
  ActiveLinkProvider,
  ActiveMenuProvider,
  InspirationTilesProvider,
  JoinTilesProvider,
  LabelsProvider,
  PbsContentProvider,
  SearchInputProvider,
  ShopSectionProvider,
} from '../context/navigation';
import { composeProviders } from '../utils';
import { ApiProvider } from './ApiProvider';

export const Context = composeProviders(
  ApiProvider,
  UserSegmentationDataProvider,
  HeadersProvider,
  AppPromoProvider,
  PbsContentProvider,
  SearchInputProvider,
  ActiveLinkProvider,
  ActiveMenuProvider,
  ConsultantProvider,
  TopAreaBannerProvider,
  AboutTilesProvider,
  InspirationTilesProvider,
  JoinTilesProvider,
  LabelsProvider,
  ShopSectionProvider,
  CataloguesProvider,
);
